// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonPlaceholder_wrapper__vrXY7","activity":"SkeletonPlaceholder_activity__giYGR","loading":"SkeletonPlaceholder_loading__9iJQ9"};